export const SECRET_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
        MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAtTexRUEM0noZbQPers7j
        AAy+U3jDFm7gmWmTVp75xSEayznO3wKT1M45msZaZqWWAsIXkvqAtogelGY0J2Fh
        3+XvuaR8E84cxm5J/C+XW78u1iYZgaIllheioLJgiqUSe5vSRdxlybgNAQ8q0qh6
        4vhQXirAqfNDGrX2XBfcIihgthD+yTu7xygVArEgbSSYrqkDgWBYPLqXy3NLfWZ3
        2Ikv2MRCTLEhfz3tREI3xC4IvsIuAxjT2VikODDaw09L08ADqKoUTszJ0KJDevSj
        1z3DMEY68RK0EV2ChAyVFwkFN7zHgieYv2+TJGs62mGFRb06ivcVXd4P+RLCh6wC
        Yb0PsUFWly9AuHv06AMVYnXdCXsaDHADLs8u3hxdIxQNzd6Kf8OP9f2y4n6iO1oT
        cKZ/725tmtt43LqRTU1OI2o2UVoQ93Q5zlTbJZb1NP4AbqIbO63thI094PcEb+k0
        sC3kYlMCrR18QUWM96Qa58Kjk/vO3PiYyx2T3DVYseI5wZruKpy01Lv6v2WMhw0O
        DToQWpnRMMC2NC3e2Zod/eaVD/RCb75EN8a4xUm4DFWpHGdk4puiPGCIgwNFymNv
        IFjlJDnHC2HI4yKqP4prH0NE6PcWvym/2QMIhKteAjzDCot0V/HbkFYWtFlN1Nle
        7IFqhSWa7y7zM9z1Erl4kv8CAwEAAQ==
        -----END PUBLIC KEY-----`;

export const SSO_API_URL = 'https://sso.kplogic.com/api';

export const REACT_ENV = 'production'; // development, staging, production

export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyDXgV9oz5wQcyF2qM9GFh0WYA9tKG0R9dU',
  authDomain: 'optimize-3cfb4.firebaseapp.com',
  projectId: 'optimize-3cfb4',
  storageBucket: 'optimize-3cfb4.appspot.com',
  messagingSenderId: '303168401751',
  appId: '1:303168401751:web:aa6458db86e13c5233ce12',
  measurementId: 'G-FD2ET1P9CD'
};

export const FIREBASE_VAPID = 'BHi4RBcwygvS52LC9VzDJMzkLIl3O1E8RAFGij2zPFibj47P9tD9-06qPobI5EADGVk1lfVHbIouoVuywe7XFak';

export const BUGSNAG_CONFIG = {
  apiKey: '3b5a7ae30aa8c16b2100a64496bb402a',
  enabledReleaseStages: ['development', 'production'],
  releaseStage: `${REACT_ENV}`
};

export const INDEXED_DB_ENC_KEY = 'S,?,a,M,w,^,&,m,B,W,Y,V,^,!,d,+,%,r,b,m,b,3,Z,^,L,4,X,3,q,B,*,5';

export const SCANDIT_KEY = 'AZIOg7+BKzWICPhn0AVSHI4cjgXiF0GXyGNIBKBppnHFershrXirhv5B95nhTJe4sUJq6nksCzcuUQJncW+SBv93s33ZbJ+yzQyKT5xGJ8/oTaXmxkAw660kfXKSQKI1ch8SB6URZWW3dYt1ClFhqa5/hZXjHS3nW6amydgno3dpVWEgQcVrx1f/cjrB3n2ovzaBNvrrLHsdfV3n92DQrV5wovWq0VJOkZJtHcHHdJLAbQSVi12+KcpNTl7bwhW/m+HKWpHU57qAjyJXuv5pYlx+AB3WjP8SBVIw6RIsneIYgFFUe+SHoaG6FVvMqwY/c5MaOMp8g219nngkLfg17Xfcwb3eJUowK6iwnUC6z92hSMJGM//pRN5D+BAd+BKV7Onkye5oXHwkiykHM9KjO1o8U6xQVFkAXYK3cUQvlHZHMYXAvtrPKV0MlQMWnC01SRYykP/ROzTgDeEj5OSfEtx1tgieZBHVls+hdPk06AEdcuyXJv8/W1mh+9s27ifWb0x1pvTL9yLbgUAj6ImPNB5LjzL2YLctxtpP4BwjEb6u7jPI9BbEyNa4pj+Hk6u0S3rAoPxIONkmTLa8AvXNxeN5NMAzrOgIpCHogNSBBppt6tQhGfxAOIkaA0O9RaQEo6T1zJLtrFDBOI4wJw7Web6k20NS8x2VvrbX+/Xa7KJZpj/D1ONv+FzSEDKGMQlJ/lrQrLILkxsx8mvBOdM+6R/96Yl8zaBYeqeSzlRgZGTcEL/Ivdi/TW6Qo624wABnogpJm1oqu6UoNHU8S4nxvXA65C4mHUJAnB91IycjZqV1px8=';

export const APP_VERSION = '9.6.0';
export const API_VERSION = 'V2';
export const REQUEST_SOURCE = 'website';
export const APP_GENERATION = 'NEW';

export const upgradeUrl = 'https://www.kplogic.com/';

export const INVENTORY_INFO = '- P = Par Values (if entered by the office) \n '
    + '- C = Consigned Inventory \n '
    + '- S = Scanned Inventory \n '
    + '- V = Variance \n '
    + '- Scan sessions are automatically deleted from your device after 7 days. \n '
    + '- Consignment Inventory is typically updated once daily by the office. \n '
    + '- Scanning can occur independent of syncing inventory.';
export const API_VERSION_V3 = 'V3';
